export const handleShare = async (product) => {
    if (navigator.share) {
        try {
            await navigator.share({
                title: product.name,
                text: 'Revisa este producto increíble:',
                url: `${window.location.origin}/product/${product._id}`,
            });
        } catch (err) {
            console.error('Error sharing:', err);
        }
    } else {
        alert('Tu navegador no soporta la función de compartir.');
    }
};

export const handleWhatsApp = (product, messageType = 'help', selectedVariations = {}) => {
    let text;
    if (messageType === 'availability') {
        const variationText = Object.entries(selectedVariations)
            .filter(([, option]) => option?.name)
            .map(([type, option]) => `${type}: ${option.name}`)
            .join(', ');
        text = `Hola! quisiera confirmar la disponibilidad de ${product.name}${variationText ? ` (${variationText})` : ''}: ${window.location.origin}/product/${product._id}`;
    } else {
        text = `Hola! necesito ayuda con este producto: ${window.location.origin}/product/${product._id}`;
    }
    const url = `https://api.whatsapp.com/send?phone=${process.env.REACT_APP_WHATSAPP_PHONE}&text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
};

export const isLinkedVariation = (variation) => {
    if (!variation?.options?.length) return false;
    return variation.options.every((opt) => typeof opt?.linkedProduct === 'string' && opt.linkedProduct.trim());
};

export const variationNeedsAvailabilityConfirmation = (variation) => {
    if (!variation?.options?.length) return false;
    return variation.options.some(
        (opt) => !(typeof opt?.linkedProduct === 'string' && opt.linkedProduct.trim())
    );
};

export const getVariationsNeedingAvailabilityConfirmation = (variations = []) =>
    variations.filter((variation) => variationNeedsAvailabilityConfirmation(variation));

export const buildLinkedVariationPicker = (product, variation, preferredOrderIds = []) => {
    if (!product?._id || !variation?.options?.length) return [];

    const pickerOptions = variation.options
        .filter((opt) => typeof opt?.linkedProduct === 'string' && opt.linkedProduct.trim())
        .map((opt) => ({
            id: opt.linkedProduct,
            label: opt.name,
            isCurrent: opt.linkedProduct === product._id,
        }));

    const hasCurrentOption = pickerOptions.some((opt) => opt.id === product._id);
    if (!hasCurrentOption) {
        pickerOptions.push({
            id: product._id,
            label: product.name,
            isCurrent: true,
        });
    }

    const uniqueById = [];
    const seenIds = new Set();
    pickerOptions.forEach((opt) => {
        if (!seenIds.has(opt.id)) {
            seenIds.add(opt.id);
            uniqueById.push(opt);
        }
    });

    if (!Array.isArray(preferredOrderIds) || preferredOrderIds.length === 0) {
        return uniqueById;
    }

    const optionById = new Map(uniqueById.map((opt) => [opt.id, opt]));
    const ordered = [];

    preferredOrderIds.forEach((id) => {
        const option = optionById.get(id);
        if (option) {
            ordered.push(option);
            optionById.delete(id);
        }
    });

    uniqueById.forEach((opt) => {
        if (optionById.has(opt.id)) {
            ordered.push(opt);
            optionById.delete(opt.id);
        }
    });

    return ordered;
};
